<script setup>
import TailwindLayout from '@/Layouts/TailwindLayout.vue'
import Pagination from "@/Shared/Pagination.vue";
const props = defineProps({
    audits: Object,
})
</script>

<template>
    <TailwindLayout title="Audit Logs">
        <template #header>
            Audit Logs
        </template>
        <div class="py-6">
            <div class="overflow-x-auto rounded-b-md bg-white">
                <div class="overflow-x-auto overflow-y-auto">
                    <div class="inline-block min-w-full align-middle">
                        <div class="overflow-hidden shadow">
                            <table
                                class="min-w-full divide-y divide-gray-200"
                            >
                                <thead class="bg-gray-50">
                                <tr>
                                    <th
                                        scope="col"
                                        class="px-6 py-3 text-left text-xs font-bold uppercase tracking-wider text-gray-500"
                                    >
                                        User Name
                                    </th>

                                    <th
                                        scope="col"
                                        class="px-6 py-3 text-left text-xs font-bold uppercase tracking-wider text-gray-500"
                                    >
                                        Event
                                    </th>
                                    <th
                                        scope="col"
                                        class="px-6 py-3 text-left text-xs font-bold uppercase tracking-wider text-gray-500"
                                    >
                                        Auditable
                                    </th>
                                    <th
                                        scope="col"
                                        class="px-6 py-3 text-left text-xs font-bold uppercase tracking-wider text-gray-500"
                                    >
                                        Old Values
                                    </th>
                                    <th
                                        scope="col"
                                        class="px-6 py-3 text-left text-xs font-bold uppercase tracking-wider text-gray-500"
                                    >
                                        New Values
                                    </th>

                                    <th
                                        scope="col"
                                        class="px-6 py-3 text-left text-xs font-bold uppercase tracking-wider text-gray-500"
                                    >
                                        URL
                                    </th>

                                    <th
                                        scope="col"
                                        class="px-6 py-3 text-left text-xs font-bold uppercase tracking-wider text-gray-500"
                                    >
                                        IP Address
                                    </th>
                                    <th
                                        scope="col"
                                        class="px-6 py-3 text-left text-xs font-bold uppercase tracking-wider text-gray-500"
                                    >
                                        Created At
                                    </th>

                                </tr>
                                </thead>
                                <tbody class="divide-y divide-gray-200">
                                <tr
                                    v-for="(audit, index) in audits.data"
                                    :key="index"
                                    class=""
                                >
                                    <td
                                        class="whitespace-wrap py-4 px-6 text-sm font-medium text-gray-900"
                                    >
                                        {{ audit.user?.name }}
                                    </td>
                                    <td
                                        class="whitespace-rap px-6 py-4 text-sm text-gray-500"
                                    >
                                        {{ audit.event }}
                                    </td>
                                    <td
                                        class="whitespace-wrap px-6 py-4 text-sm text-gray-500"
                                    >
                                        {{ audit.auditable_type }}
                                    </td>
                                    <td
                                        class="whitespace-wrap px-6 py-4 text-sm font-medium"
                                    >
                                        {{ audit.old_values }}
                                    </td>
                                    <td
                                        class="whitespace-wrap px-6 py-4 text-sm font-medium"
                                    >
                                        {{ audit.new_values }}
                                    </td>
                                    <td
                                        class="whitespace-wrap px-6 py-4 text-sm font-medium"
                                    >
                                        {{ audit.url }}
                                    </td>
                                    <td
                                        class="whitespace-wrap px-6 py-4 text-sm font-medium"
                                    >
                                        {{ audit.ip_address }}
                                    </td>
                                    <td
                                        class="whitespace-wrap px-6 py-4 text-sm font-medium"
                                    >
                                        {{ audit.created_at }}
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="flex flex-col">
                    <table>
                        <tbody>
                            <tr v-show="audits.data.length">
                            <td
                                colspan="6"
                                class="whitespace-nowrap bg-white px-6 py-4 text-center text-sm font-medium DD"
                            >
                                <pagination
                                    class="mt-6"
                                    :links="audits.links"
                                    :results="audits"
                                    :type="'Audit Logs'"
                                />
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </TailwindLayout>
</template>
